// extracted by mini-css-extract-plugin
export default {"modal":"AddPostModal_modal__8zKz6","modal_area":"AddPostModal_modal_area__iEqFn"};